import React, { useState } from 'react'
import AppConfig from '@/app-config.js'
import classNames from 'classnames'
import type { Props } from './types'
import styles from './style.module.scss'

const Image: React.FC<Props> = ({ data, extraClasses }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const classes = classNames(
    styles['image'],
    {
      [styles['is-loaded']]: isLoaded,
    },
    [extraClasses]
  )

  return (
    <img
      onLoad={() => setIsLoaded(true)}
      className={classes}
      width={data.data.attributes.width}
      height={data.data.attributes.height}
      src={`${AppConfig.apiUrl}${data.data.attributes.url}`}
      alt={data.data.attributes.caption}
    />
  )
}

export default Image
